import * as React from "react";
const SvgFiRrLessThanEqual = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 23a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1m-.605-5.92L5.815 10.82c-.601-.258-.814-.851-.814-1.32 0-.467.214-1.061.814-1.318l14.58-6.262a1 1 0 0 0-.789-1.837L5.024 6.342C3.775 6.88 3 8.09 3 9.5s.776 2.62 2.025 3.157l14.581 6.262a1 1 0 1 0 .789-1.837z"
    />
  </svg>
);
export default SvgFiRrLessThanEqual;
